import { Helmet } from 'react-helmet';
import { getPath } from '../../config';
import useBodyBackground from '../../hooks/useBodyBackground';
import useContentForBuild from '../../hooks/useContentForBuild';

export default function Gated() {
  useBodyBackground(`url(${getPath('bg_general')}) no-repeat top center fixed #000`);
  const [content] = useContentForBuild();

  return (
    <>
      {content && (
        <>
          <Helmet>
            <title>{content.error}</title>
            <meta name="description" content={content.error} />
          </Helmet>
          <div className="error-page">
            <div>
              <h1>{content.unableToProceedHeading}</h1>
              <p>{content.unableToProceedDesc}</p>
            </div>
          </div>
        </>
      )}
    </>
  );
}
